import { createFileRoute } from '@tanstack/react-router'
import { TrainersBlockedPage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainers/blocked')({
  component: TrainersBlockedPage,
})
